import { colors } from "./colors";

import type { IChipValueType } from "@components/atoms/chip/types";

export const getColor = (name: IChipValueType) => {
  return colors[name as IChipValueType] || colors.default;
};
